import { useEffect, useCallback } from 'react';
import { useDialogClose } from '../hooks/useDialogClose';

interface PastedTextPreviewProps {
  text: string;
  filename: string;
  onClose: () => void;
}

export function PastedTextPreview({ text, filename, onClose }: PastedTextPreviewProps) {
  const { isClosing, handleClose } = useDialogClose(onClose);

  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    if (e.key === 'Escape') handleClose();
  }, [handleClose]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return (
    <div className={`pasted-text-overlay${isClosing ? ' overlay-closing' : ''}`} onClick={handleClose}>
      <div
        className={`pasted-text-modal${isClosing ? ' dialog-closing' : ''}`}
        role="dialog"
        aria-label={`Preview: ${filename}`}
        onClick={e => e.stopPropagation()}
      >
        <div className="pasted-text-header">
          <span className="pasted-text-title">{filename}</span>
          <button className="pasted-text-close" onClick={handleClose} aria-label="Close">×</button>
        </div>
        <pre className="pasted-text-content">{text}</pre>
      </div>
    </div>
  );
}
